const FeaturedSection = ({ featuredArticles, onArticleClick }) => {
  if (featuredArticles.length === 0) return null;

  return (
    <section className="mb-16">
      <h3 className="text-2xl font-bold text-white mb-6 text-center">Featured Articles</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {featuredArticles.map((article) => (
          <button
            key={article.id}
            data-testid={`featured-${article.id}`}
            onClick={() => onArticleClick(article.id)}
            className="group relative aspect-square rounded-xl overflow-hidden border border-slate-800 hover:border-blue-500 transition-all text-left cursor-pointer"
          >
            {article.thumbnail_url ? (
              <img
                src={article.thumbnail_url}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform"
              />
            ) : (
              <div className="w-full h-full bg-slate-800 flex items-center justify-center">
                <svg className="w-12 h-12 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                </svg>
              </div>
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex items-end p-3">
              <p className="text-white text-sm font-medium line-clamp-2">{article.title}</p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default FeaturedSection;
